export function setProjectBalanceList(state, payload) {
    state.projectBalanceList = payload || [];
}

export function setLoading(state, payload) {
    state.loading = payload;
}



// WEBPACK FOOTER //
// ./src/modules/project-balance/mutations.js